import { createTheme } from "@mui/material";

export const izakayaTheme = createTheme({});
